import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import b from 'b_';
import cn from 'classnames';
import './FuseProgressIndicator.css';

const block = b.lock('FuseProgressIndicator');

export const PROGRESS_INDICATOR_TYPES = {
    CIRCULAR: 'circular',
    LINEAR: 'linear',
};

export const PROGRESS_INDICATOR_SIZES = {
    LARGE: 'large',
    MEDIUM: 'medium',
    SMALL: 'small',
};

export default class FuseProgressIndicator extends Component {
    static propTypes = {
        type: PropTypes.oneOf(Object.values(PROGRESS_INDICATOR_TYPES)),
        size: PropTypes.oneOf(Object.values(PROGRESS_INDICATOR_SIZES)),
        progress: PropTypes.number,
    };

    static defaultProps = {
        type: PROGRESS_INDICATOR_TYPES.CIRCULAR,
        size: PROGRESS_INDICATOR_SIZES.MEDIUM,
    };

    renderCircularProgressIndicator = () => {
        const { size } = this.props;

        return <div className={block('SpinnerContainer', { size })}>
            <svg
                className={cn(block('SVG'))}
                viewBox="0 0 100 100"
            >
                <circle
                    className={block('Spinner', { size })}
                    cx="50%"
                    cy="50%"
                />
            </svg>
        </div>;
    };

    renderLinearProgressIndicator = () => {
        const { progress } = this.props;
        const indeterminate = progress == null;
        const fixedProgress = Math.max(0, Math.min(100, progress)) + '%';

        return <div className={block('ProgressBarContainer')}>
            {indeterminate ? <Fragment>
                <div className={block('ProgressBarValue', { indeterminate: 'increase' })} />
                <div className={block('ProgressBarValue', { indeterminate: 'decrease' })} />
            </Fragment> : (
                <div className={block('ProgressBarValue')} style={{ width: fixedProgress }} />
            )}
        </div>;
    };

    render() {
        const { type } = this.props;

        return <Fragment>
            {type === PROGRESS_INDICATOR_TYPES.CIRCULAR ?
                this.renderCircularProgressIndicator() :
                this.renderLinearProgressIndicator()}
        </Fragment>;
    }
}

